import { useTheme } from "next-themes";
import { Sun, Moon, Coffee, Circle } from "lucide-react";
import { useEffect, useState } from "react";

const OPTIONS = [
  { key: "dark", label: "Dark", icon: Moon },
  { key: "light", label: "Light", icon: Sun },
  { key: "vintage", label: "Vintage", icon: Coffee },
  { key: "matte", label: "Matte", icon: Circle },
];

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const current = mounted ? theme : "dark";

  return (
    <div
      data-testid="theme-toggle"
      className="grid grid-cols-4 gap-1 rounded-lg border border-border bg-secondary/40 p-1"
    >
      {OPTIONS.map((o) => {
        const isActive = current === o.key;
        return (
          <button
            key={o.key}
            onClick={() => setTheme(o.key)}
            data-testid={`theme-${o.key}`}
            title={`${o.label} theme`}
            className={`flex items-center justify-center gap-1 rounded-md px-1.5 py-1.5 text-[11px] font-medium transition-colors ${
              isActive
                ? "bg-primary/15 text-primary"
                : "text-muted-foreground hover:bg-secondary hover:text-foreground"
            }`}
          >
            <o.icon className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
